import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { EntityDetailResolver } from 'src/app/core/services/entity-detail.resolver';
import { LiftService } from './lift.service';
import { LiftDetail } from '../models/lift-detail.model';


@Injectable({ providedIn: 'root' })
export class LiftDetailResolver extends EntityDetailResolver<LiftService, LiftDetail> {
  constructor(
    liftService: LiftService
  ) {
    super(liftService);
  }
}
